import Grid from '@mui/material/Grid2';
import logo from "../../Assets/Logos/login-mac-logo.png"
import { Divider, IconButton, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import styles from "../../Styles/ComponentStyles/MainPages/VerifyEmail.module.scss"
import globalStyles from "../../Styles/global.module.scss"
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import ComplianceDocument from '../../Components/ComplianceDocument/ComplianceDocument';
import { useIsBelow1200, useIsBelow900 } from '../../Utils/Constant/Constant';
import React, { useContext, useEffect } from 'react';
import agent from '../../Services/api';
import { GlobalUserContext, GlobalUserContextPayload } from '../../Context/GlobalUserDetailContext';
import { useSnackbar } from '../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import { DashboardContext, DashboardDetailPayload } from '../../Context/DashboardDetailContext';
import { forgotPasswordEmailInterface } from '../../models/axiosModels';
import SideNavigationPanel from '../../Components/SideNavigationPanel/SideNavigationPanel';

const VerifyEmail = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate()
    const { showSnackbar } = useSnackbar();
    const isBelow900 = useIsBelow900()

    const {
        drawerOpen,
        userDetails,
        setFlagLoader,
        userProfileDetails,
        setUserProfileDetails
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const {
        setDashboardDetails
    } = useContext(DashboardContext) as DashboardDetailPayload

    const isBelow1200 = useIsBelow1200()
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerClose = () => {
        setMobileOpen(false);
    };

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    useEffect(() => {
        const verifyToken = searchParams.get('token');
        if (verifyToken) {
            setFlagLoader(true)
        } else if (!userProfileDetails.flagLoggedIn) {
            navigate("/")
        }

        const verify = async () => {
            try {
                const payload = {
                    token: verifyToken
                }
                const response = await agent.verifyUser.post(payload);
                // console.log("response of verify", response);
                const res = response.response;

                if (response?.status === true) {
                    // console.log("response of verify status true", response);
                    setFlagLoader(false)
                    showSnackbar("User Successfully Verified!", "success");
                    await initializeAuth()
                }
                else {
                    setFlagLoader(false)
                    if (userProfileDetails.flagLoggedIn) {
                        // console.log("response of verify in flagLoggedIn", response);
                        const error = res?.data?.error?.message ? response?.data?.error?.message : "Something Went Wrong!";
                        showSnackbar(error, "error")
                    }
                    else {
                        // console.log("response of verify in flagLoggedIn else", response);
                        navigate('/');
                    }
                }
            }
            catch (err) {
                console.log("response error of verify in catch", err);
                setFlagLoader(false)
                if (userProfileDetails.flagLoggedIn) {
                    showSnackbar("Something Went Wrong!", "error")
                } else {
                    navigate('/');
                }
            }
        };
        if (verifyToken) verify();
    }, [])

    const handleResendVerification = async () => {
        try {
            if (userProfileDetails.user.email) {
                const payload: forgotPasswordEmailInterface = {
                    email: userProfileDetails.user.email
                }
                setFlagLoader(true)
                const response = await agent.resendVerifyUser.post(payload);
                if (response.status) {
                    setFlagLoader(false)
                    showSnackbar(response.message, 'success')
                }
                else {
                    setFlagLoader(false);
                    showSnackbar(response.error.message, 'error')
                }
            }
        } catch (error) {
            console.log("Error during resend email verification", error);
            showSnackbar("Something Went Wrong!", "error")
        }
    }

    const initializeAuth = async () => {
        try {
            setFlagLoader(true);
            const response = await userDetails();
            if (response?.status && response?.data) {
                const userMeResponse = response.data
                setUserProfileDetails({
                    ...userProfileDetails,
                    flagLoggedIn: true,
                    user: response.data.user,
                    accessToken: response.data.accessToken,
                    apps: response.data.apps
                });
                if (userMeResponse.apps) {
                    setDashboardDetails({ apps: userMeResponse.apps });
                }
                setFlagLoader(false);
            }
            else {
                navigate('/');
                setUserProfileDetails(prevState => ({ ...prevState, flagLoggedIn: false }));
                setFlagLoader(false);
            }
        } catch (error) {
            console.error('Auth initialization error:', error);
            setUserProfileDetails(prevState => ({ ...prevState, flagLoggedIn: false }));
            navigate('/');
            setFlagLoader(false);
        }
    };

    return (
        <>
            <Grid container className={`${globalStyles.mainContainer}`}>
                <Grid size={{ xs: 12 }} className={`${globalStyles.fullHeightStyle}`}>
                    <Grid container className={`${globalStyles.fullHeightStyle}`}>
                        <Grid
                            className={`${globalStyles.fullHeightStyle}`}
                            sx={{
                                width: `${isBelow1200 ? "0px" : drawerOpen ? "250px" : '80px'}`
                            }}
                        >
                            <SideNavigationPanel
                                handleDrawerClose={handleDrawerClose}
                                mobileOpen={mobileOpen}
                            />
                        </Grid>
                        <Grid
                            className={`${globalStyles.fullHeightStyle} ${globalStyles.globalContentBgWrapper}`}
                            sx={{
                                width: `${isBelow1200 ? "100%" : drawerOpen ? "calc(100% - 250px) !important" : "calc(100% - 80px) !important"}`,
                                maxWidth: `${isBelow1200 ? "100%" : drawerOpen ? "calc(100% - 250px) !important" : "calc(100% - 80px) !important"}`,
                                overflow: 'auto',
                                // marginTop: isBelow1200 ? "70px" : "0px"
                            }}
                        >
                            <Grid container className={`${globalStyles.gblHeaderOutletContainer}`}
                                sx={{ backgroundColor: isBelow1200 ? "#273348" : "transparent" }}
                            >
                                <Grid size={{ xs: 12 }}>
                                    <Grid container
                                        sx={{
                                            alignItems: "baseline !important",
                                            gap: "5px",
                                            padding: isBelow1200 ? "15px 10px" : "0px 20px"
                                        }}
                                    >
                                        {isBelow1200 && (
                                            <Grid sx={{ width: "30px", maxWidth: "30px" }}>
                                                <IconButton
                                                    sx={{ padding: "0px", margin: "0px", }}
                                                    onClick={handleDrawerToggle}
                                                >
                                                    <MenuIcon sx={{ color: "white", paddingBottom: "5px" }} />
                                                </IconButton>
                                            </Grid>)
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid size={{ xs: 12 }} className={`${globalStyles.globalOutletWrapper}`}>
                                    <Grid container>
                                        <Grid size={{ xs: 11 }} sx={{ margin: "auto" }}>
                                            <Grid container className={`${styles.verificationBannerItem}`}>
                                                <Grid size={{ xs: 12 }}>
                                                    <img
                                                        src={logo}
                                                        alt="Mac Acrylic Logo"
                                                        className={`${styles.verificationAcrLogo}`}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12 }}><Typography component={'span'} className={isBelow900 ? `${globalStyles.gblCWhite} ${globalStyles.globalTextV28}` : `${globalStyles.gblCWhite} ${globalStyles.globalTextV36}`}>
                                                    Verify Email
                                                </Typography></Grid>
                                                <Grid size={{ xs: 12 }}><Divider sx={{ border: "1px solid #FFFFFF" }} /></Grid>
                                                <Grid size={{ xs: 12 }}><Typography component={'span'} className={isBelow900 ? `${globalStyles.gblCWhite} ${globalStyles.globalTextV18}` : `${globalStyles.gblCWhite} ${globalStyles.globalTextV24}`}>
                                                    Before proceeding. please check email for a verification link.
                                                    if you did not receive the email<br />
                                                    <Link to="" style={{ color: '#9AD304' }} onClick={handleResendVerification}>click here to request another</Link></Typography></Grid>
                                            </Grid>
                                        </Grid>
                                        {/* footer */}
                                        <Grid size={{ xs: 12 }}><ComplianceDocument /></Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default VerifyEmail
